import { z } from 'zod'

const commonFields = {
  status: z.string({ required_error: 'Vyberte stav nehnuteľnosti.' }),
}

const flatSchema = z.object({
  ...commonFields,
  level: z
    .number({
      required_error: 'Poschodie je povinné.',
      invalid_type_error: 'Poschodie musí byť číslo.',
    })
    .int('Poschodie musí byť celé číslo.')
    .min(0, 'Poschodie nemôže byť záporné.'),

  flatNumber: z
    .string({
      required_error: 'Číslo bytu je povinné.',
      invalid_type_error: 'Číslo bytu musí byť text.',
    })
    .min(1, 'Číslo bytu nemôže byť prázdne.'),

  flatArea: z
    .number({
      required_error: 'Rozloha bytu je povinná.',
      invalid_type_error: 'Rozloha bytu musí byť číslo.',
    })
    .positive('Rozloha bytu musí byť kladná.'),
})

const houseSchema = z.object({
  ...commonFields,
  numberOfFloors: z
    .number({
      required_error: 'Počet podlaží je povinný.',
      invalid_type_error: 'Počet podlaží musí byť číslo.',
    })
    .int('Počet podlaží musí byť celé číslo.')
    .min(1, 'Počet podlaží musí byť aspoň 1.'),

  houseUsableArea: z
    .number({
      required_error: 'Úžitková plocha domu je povinná.',
      invalid_type_error: 'Úžitková plocha domu musí byť číslo.',
    })
    .positive('Úžitková plocha domu musí byť kladná.'),

  landArea: z
    .number({
      required_error: 'Plocha pozemku je povinná.',
      invalid_type_error: 'Plocha pozemku musí byť číslo.',
    })
    .positive('Plocha pozemku musí byť kladná.'),
})

export const getEstateSchema = (propertyType: 'house' | 'flat' | undefined) => {
  if (propertyType === 'flat') {
    return flatSchema
  }
  if (propertyType === 'house') {
    return houseSchema
  }
  return z.object({})
}

export type FlatScheme = z.infer<typeof flatSchema>
export type HouseScheme = z.infer<typeof houseSchema>
export type EstateScheme = FlatScheme | HouseScheme

export type FlatFormScheme = Partial<FlatScheme>
export type HouseFormScheme = Partial<HouseScheme>
export type EstateFormScheme = FlatFormScheme | HouseFormScheme

export const getFlatDefaultValues = (): FlatFormScheme => ({
  level: undefined,
  flatNumber: '',
  flatArea: undefined,
  status: undefined,
})

export const getHouseDefaultValues = (): HouseFormScheme => ({
  numberOfFloors: undefined,
  houseUsableArea: undefined,
  landArea: undefined,
  status: undefined,
})

export const getEstateDefaultValues = (
  propertyType: 'house' | 'flat' | undefined
): EstateFormScheme => {
  if (propertyType === 'flat') {
    return getFlatDefaultValues()
  }
  if (propertyType === 'house') {
    return getHouseDefaultValues()
  }
  return {}
}
